import request from '@/utils/request'

// 修改登录密码
export function changePassword(data) {
	return request({
		url: '/api/common/v1/user/changePassword',
		method: 'post',
		data
	})
}

// 修改签署pin码
export function changePin(data) {
	return request({
		url: '/api/common/v1/user/changePin',
		method: 'post',
		data
	})
}

// 修改用户名
export function changeUserNumber(data) {
	return request({
		url: '/api/common/v1/user/changeUserNumber',
		method: 'post',
		data
	})
}

// 修改绑定手机号
export function changeUserByPhone(data) {
	return request({
		url: '/api/common/v1/user/changeUserByPhone',
		method: 'post',
		data
	})
}

export function thisUserByPhoneAuth(data) {
	return request({
		url: '/api/common/v1/user/thisUserByPhoneAuth',
		method: 'post',
		data
	})
}

export function changeSmsRemindSwitch(data) {
	return request({
		url: '/api/common/v1/user/changeSmsRemindSwitch',
		method: 'post',
		data
	})
}

